import React, { Component } from 'react';
import {connect} from 'react-redux';
import ga from 'analytics';

import {fetchMyProfile} from 'actions/user.js';
import DatabaseService from 'services/DatabaseService.js';
import SurveyPageRecommendations from './SurveyPageRecommendations.js';

const topPicksDefault = [0, 1, 2];

class SurveyPageRecommendationsContainer extends Component {
    constructor(props) {
        super(props);
        var categories = [];
        var topPicks = [];
        if(this.props.surveyPage &&
           this.props.surveyPage.data &&
           this.props.surveyPage.data.categories) {
            categories = this.props.surveyPage.data.categories;
            topPicks   = topPicksDefault.filter((tp,i)=>i<categories.length);
        }
        this.state = {topPicks:topPicks,
                      pickIndex:3,
                      categories:categories};
        this.onSubmit = this.onSubmit.bind(this);
        this.onCycleCategory = this.onCycleCategory.bind(this);
    }
    componentWillMount() {
        ga('send', 'pageview', { 'page': '/virtual/survey-page-recommendations' }); 
    }
    componentWillReceiveProps(newProps) {
        var newSurveyPage = newProps.surveyPage;
        if(newSurveyPage.data && 
           newSurveyPage.data.categories && 
           newSurveyPage.data.categories.length>0 &&
           this.state.categories.length==0) {
            var categories = newSurveyPage.data.categories;
            var topPicks= topPicksDefault.filter((tp,i)=>i<categories.length);
            this.setState({categories:categories, topPicks:topPicks});
        }
    }
    onSubmit(event) {
        event.preventDefault();
        var categoryIds = this.state.topPicks.map(tp=>this.state.categories[tp].id);
        if(categoryIds.length > 0) {
            this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
            DatabaseService.batchCategorySubscribe(categoryIds)
                .then(()=>{
                    return this.props.dispatch(fetchMyProfile({categories:true}));
                })
                .catch((error)=>{
                    console.error(error);
                })
                .then(() => {
                    this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
                    this.props.onSubmit(null,null,this.state);
                });
        } else {
            this.props.onSubmit(null,null,this.state);
        }
    }
    onCycleCategory(category, index) {
        var pickIndex = this.state.pickIndex;
        while(this.state.topPicks.indexOf(pickIndex)>=0){
            pickIndex++;
            pickIndex %= this.state.categories.length;
        }
        this.setState({pickIndex:pickIndex, 
                       topPicks:this.state.topPicks.map((tp,i) => i===index ? pickIndex : tp)});
    }
    render() {
        return <SurveyPageRecommendations
                   userProfile={this.props.userProfile}
                   topPicks={this.state.topPicks}
                   categories={this.state.categories}
                   surveyPage={this.props.surveyPage}
                   inlineButtons={this.props.inlineButtons}
                   pageNum={this.props.pageNum}
                   numPages={this.props.numPages}
                   onSkip={this.props.onSkip}
                   onSubmit={this.onSubmit}
                   onCycleCategory={this.onCycleCategory}
                   />;
    }

}

export default connect()(SurveyPageRecommendationsContainer);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageRecommendationsContainer.js